import { latestTranslations } from "../translations/latest";
import { useLocation } from "react-router";
import footer from '../footer.jpg';

export default function Product() {
    const location = useLocation();
    const lang = location.pathname.split("/")[1] || "GE";
    const t = latestTranslations[lang] || latestTranslations["GE"];

    return (
        <section 
            className="relative min-h-screen pt-32 pb-24 md:pt-36 md:pb-28 px-4 sm:px-8 lg:px-12" 
            style={{ backgroundImage: `url(${footer})`, backgroundSize: 'cover', backgroundAttachment: 'fixed' }}
        >
            <div className="max-w-7xl mx-auto">
                {/* Modern Section Header */}
                <div className="text-center max-w-2xl mx-auto mb-14 md:mb-20">
                    <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-sans-georgian font-semibold text-[#800020] block mb-2 cursor-default">
                        {t.title}
                    </span>
                    <h1 className="font-serif-georgian text-3xl sm:text-4xl md:text-5xl font-bold text-stone-900 tracking-wide leading-tight mb-4 cursor-default">
                        {t.pageTitle || "ღვინის კოლექცია"}
                    </h1>
                    <div className="w-16 h-0.5 bg-[#800020]/40 mx-auto mb-4"></div>
                    <p className="font-sans-georgian text-stone-600 text-sm sm:text-base font-light leading-relaxed cursor-default">
                        {t.pageSubtitle}
                    </p>
                </div>

                {/* 3-Column Modern Responsive Grid (Items Stretch for Equal Height) */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 items-stretch">
                    {t.products.map((e, index) => (
                        <div 
                            key={e.title || index}
                            className="h-full flex flex-col justify-between bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_16px_35px_rgba(0,0,0,0.11)] transition-all duration-500 overflow-hidden group border-none"
                        >
                            {/* Scaled Bottle Container (50-70%+ Larger Showcase) */}
                            <div className="h-[340px] sm:h-[380px] md:h-[400px] w-full flex items-center justify-center pt-8 pb-4 px-6 bg-gradient-to-b from-stone-50/80 to-transparent rounded-t-2xl overflow-hidden">
                                <img 
                                    src={e.src} 
                                    alt={e.title} 
                                    className="h-full max-h-[350px] w-auto object-contain filter drop-shadow-[0_16px_22px_rgba(0,0,0,0.22)] transition-transform duration-500 group-hover:scale-105 group-hover:drop-shadow-[0_22px_30px_rgba(0,0,0,0.32)]"
                                />
                            </div>

                            {/* Card Content with Unified Equal Height Distribution */}
                            <div className="flex flex-col flex-grow p-6 sm:p-7 justify-between items-center text-center">
                                <div>
                                    <h2 className="font-serif-georgian text-2xl sm:text-3xl font-bold text-stone-900 tracking-wide mb-3 group-hover:text-[#800020] transition-colors duration-300">
                                        {e.title}
                                    </h2>
                                    <p className="font-sans-georgian text-stone-600 text-sm sm:text-base leading-relaxed font-light mb-6">
                                        {e.description}
                                    </p>
                                </div>

                                {/* Call to Action (CTA) Button */}
                                <div className="mt-auto w-full pt-2">
                                    <a 
                                        href="#footer"
                                        className="w-full inline-flex items-center justify-center gap-2.5 py-3 px-6 rounded-xl bg-stone-50 hover:bg-[#800020] text-stone-800 hover:text-white border border-stone-200 hover:border-[#800020] font-serif-georgian text-sm font-semibold transition-all duration-300 shadow-sm hover:shadow-md group/btn"
                                    >
                                        <span>{t.cardCta || "ვრცლად"}</span>
                                        <span className="inline-block transition-transform duration-300 group-hover/btn:translate-x-1.5 font-sans">→</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}